import { Component, HostBinding, inject, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { TranslateService } from '@ngx-translate/core';
import { IconDirective } from '../../directives/icon.directive';

@Component({
  selector: 'lv-system-test-item',
  templateUrl: './system-test-item.component.html',
  styleUrls: ['./system-test-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [IconDirective]
})
export class SystemTestItemComponent implements OnInit {
  private translate = inject(TranslateService);
  private sanitizer = inject(DomSanitizer);

  @Input() icon: string;
  @Input() key: string;
  @Input() labelParams: any;
  @Input() working: boolean;

  label: string;
  failure: SafeHtml;

  @HostBinding('class.is-success') get isSuccess() {
    return this.working;
  }
  @HostBinding('class.is-failure') get isFailure() {
    return !this.working;
  }

  ngOnInit() {
    const failureKey = `system-test-item.component.${this.key}.failure`;
    this.translate.get(failureKey, this.labelParams).subscribe((text) => {
      this.failure = this.sanitizer.bypassSecurityTrustHtml(text);
    });

    const labelKey = `system-test-item.component.${this.key}.label`;
    this.translate.get(labelKey, this.labelParams).subscribe((text) => (this.label = text));
  }

  stateIcon(): string {
    return this.working ? 'check' : 'ban';
  }
}
